import script from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__